module.exports = __webpack_public_path__ + "img/date_ico.2d89582c.svg";